module.exports = "https://cdn.realtymogul.com/static/media/icon_targeted_market.7a6708e9.svg";